import { useConfigStore } from 'shared/store/configSlice'
import { checkIsLoggedIn } from './checkIsLoggedIn'
import { configureAmplify } from './configureAmplify'
import { setMUILicenseKey } from './setMUILicenseKey'
import { useBranchStore } from 'shared/store/branchesSlice'
import { consoleError } from './consoleError'

type LoadInitDataType = () => Promise<void>

export const initApp = (setIsLoading: (value: boolean) => void): [LoadInitDataType] => {
  const loadConfig = useConfigStore.getState().loadConfig
  const getBranchList = useBranchStore.getState().getBranchList

  const loadInitData = async () => {
    try {
      await firstStep()
      await secondStep()
      await thirdStep()
    } catch (e) {
      consoleError(e)
    } finally {
      setIsLoading(false)
    }
  }

  const firstStep = async () => await Promise.all([setMUILicenseKey(), configureAmplify()])
  const secondStep = async () => await Promise.all([checkIsLoggedIn(), getBranchList()])
  const thirdStep = async () => await Promise.all([loadConfig()])

  // TODO: GET.captions and config(0) for loading secondary data

  return [loadInitData]
}
